

























import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';
import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import SuperBet from '@modules/eventGrid/components/markets/superBets/SuperBet.vue';
import { useEventFormattedDate } from '@modules/shared/event/composeable/date';
import { BetslipStore } from '@store/modules/ui/betSlip';
import OfferEvent from '@core/models/offer/OfferEvent';
import Odd from '@core/models/offer/Odd';
import { ExpandedEventInUrl } from '@src/app/enums';
import { getUniqueTournamentId } from '@store/modules/ui/sportOffer/marketFilters/helpers';
import { getEventSlugFromEvent } from '@modules/eventDetailsPage/utils';
import { RouteName } from '@src/app/router/constants/RouteName';
import { useAnalytics } from '@sportOfferFederation/bet-builder/store/composition/useAnalytics';
import { SelectionSourceScreen } from '@superbet-group/web.types';
import EventBettorNumber from '@shared/event/EventBettorNumber.vue';
import { NavigationDataStore } from '@store/modules/navigation';
import { PeerUrgencyExperimentVariant } from '@core/models/user/flags';

export default defineComponent({
    name: 'PopularSuperbet',
    props: {
        index: {
            type: Number,
            required: true,
        },
        event: {
            type: Object as PropType<OfferEvent>,
            required: true,
        },
        odd: {
            type: Object as PropType<Odd>,
            required: true,
        },
        superbetsMarketGroupId: {
            type: Number,
            required: true,
        },
        sourceScreen: {
            type: Number as PropType<SelectionSourceScreen>,
            required: true,
        },
        bettorNumber: {
            type: Number as PropType<number>,
            required: false,
            default: -1,
        },
        socialProofDesignVariant: {
            type: String as PropType<PeerUrgencyExperimentVariant>,
            required: false,
            default: PeerUrgencyExperimentVariant.None,
        },
    },
    setup(props) {
        const navigationStore = useVuexStore<NavigationDataStore>('navigation');
        const betslipStore = useVuexStore<BetslipStore>('ui/sportOffer/betSlip');
        const { formattedDate } = useEventFormattedDate(props.event.date);
        const eventOddMap = betslipStore.getter('eventOddMap');
        const isSuperbetSelected = computed(() => {
            if (!props.event) {
                return false;
            }
            return !!eventOddMap.value[props.event.id]?.has(props.odd.uuid);
        });

        const { router } = useVueRouter();

        const route = computed(() => {
            const { route } = router.value.resolve({
                name: RouteName.Sport.OfferEvent,
                params: { eventSlug: getEventSlugFromEvent(props.event) },
                query: {
                    [ExpandedEventInUrl.type]: getUniqueTournamentId(
                        'offer',
                        props.event.tournamentId,
                        props.event.isOngoing(),
                    ),
                    [ExpandedEventInUrl.marketGroup]: props.superbetsMarketGroupId.toString(),
                },
            });

            return route;
        });

        const { superbetsCardClicked } = useAnalytics();
        function handleCardClick(): void {
            superbetsCardClicked({
                index: props.index,
                eventId: props.event.id,
            });
        }

        const toggleSelection = betslipStore.action('toggleSelection');
        function handleOddClick() {
            toggleSelection({
                index: props.index,
                eventId: props.event.id,
                oddId: props.odd.id,
                uuid: props.odd.uuid,
                specialBetValue: props.odd.specialBetValue,
                sourceScreen: props.sourceScreen,
            });
        }

        return {
            isOnHomePage: navigationStore.getter('isOnHomePage'),
            formattedDate,
            isSuperbetSelected,
            route,
            handleCardClick,
            handleOddClick,
        };
    },
    components: {
        SuperBet,
        EventBettorNumber,
    },
});
